export const IconPerson = ({ className }: { className?: string }) => (
  <svg className={`fill-current ${className}`} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11ZM12 5C13.1046 5 14 5.89543 14 7C14 8.10457 13.1046 9 12 9C10.8954 9 10 8.10457 10 7C10 5.89543 10.8954 5 12 5ZM5 20C5 16.134 8.13401 13 12 13C15.866 13 19 16.134 19 20C19 20.5523 18.5523 21 18 21C17.4477 21 17 20.5523 17 20C17 17.2386 14.7614 15 12 15C9.23858 15 7 17.2386 7 20C7 20.5523 6.55228 21 6 21C5.44771 21 5 20.5523 5 20Z"
    />
  </svg>
)
